import AppGrid from "@layout/AppGrid";
import PageHeader from "@layout/PageHeader";
import ConversationList from "@widgets/Inbox/ConversationList";
import React from "react";
import styles from "./Finanzen.module.css";

const widgets = {
  match_result: <ConversationList />,
};

const Inbox = () => {
  return (
    <>
      <PageHeader title="Chat" className={styles.pageHeader} />
      <AppGrid id="finanzen" className={styles.grid} widgets={widgets} />
    </>
  );
};

export default Inbox;
